import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { QuestionCard } from "../common";

const questionOptions = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

export const Question2 = ({
  updateQuestion,
  jurisdiction,
  answer,
  updateAnswer,
}) => {
  const [selection, setSelection] = useState(answer || "");
  const navigate = useNavigate();

  const handleSelectionChange = (value) => {
    setSelection(value);
    updateAnswer(value);
    sessionStorage.setItem("answer_q2", value);
  };

  const isNextDisabled = selection === "" || !selection;

  const handleNext = () => {
    if (selection === "yes") {
      navigate("/cannot-help", { state: { contentKey: "q2_employment" } });
    } else {
      jurisdiction === "nhs" ? updateQuestion(4) : updateQuestion(5);
    }
  };

  return (
    <QuestionCard
      question="Do you work for the organisation and want to complain about an employment matter?"
      options={questionOptions}
      required={true}
      selectedValue={selection}
      onChange={handleSelectionChange}
      onPrevious={() => updateQuestion(1)}
      onNext={handleNext}
      showPrevious={true}
      nextDisabled={isNextDisabled}
      name="employment-matter"
    />
  );
};

Question2.propTypes = {
  updateQuestion: PropTypes.func,
  jurisdiction: PropTypes.string,
  answer: PropTypes.string,
  updateAnswer: PropTypes.func,
};
